import './MenuButton.css';
import { IconButton } from '@mui/material';
import { Ellipsis } from 'lucide-react';
import React from 'react';

import MenuBox from '../MenuBox/MenuBox';

interface MenuButtonProps {
    children: React.ReactNode;
}

function MenuButton(props: MenuButtonProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    return (
        <div>
            <IconButton
                size="small"
                onClick={(e): void => {
                    setAnchorEl(e.currentTarget);
                }}
            >
                <Ellipsis size={20} />
            </IconButton>
            {/* <RoundIconButton icon={<MoreVert />} helperText={''} size='small' onClick={function (e): void
            {
                setAnchorEl(e.currentTarget)
            }} /> */}
            {anchorEl && (
                <MenuBox anchor={anchorEl} setAnchor={(newAnchor) => setAnchorEl(newAnchor)}>
                    {props.children}
                </MenuBox>
            )}
        </div>
    );
}

export default MenuButton;
